import * as types from './mutation_types'

export default {
  [types.PROJECT_ID] (state, value) {
    state.id = value
  },
  [types.PROJECT_NAME] (state, value) {
    state.nom = value
  },
  [types.PROJECT_CODE] (state, value) {
    state.code = value
  },
  [types.PROJECT_CONTACT_NAME] (state, value) {
    state.contactNom = value
  },
  [types.PROJECT_CONTACT_TEL1] (state, value) {
    state.contactTel1 = value
  },
  [types.PROJECT_CONTACT_TEL2] (state, value) {
    state.contactTel2 = value
  },
  [types.PROJECT_CONTACT_EMAIL] (state, value) {
    state.contactEmail = value
  },
  [types.PROJECT_CONTACT_ADRESSE] (state, value) {
    state.adresse = value
  },
  [types.PROJECT_CONTACT_COMPLEMENT_ADRESSE] (state, value) {
    state.complementAdresse = value
  },
  [types.PROJECT_CONTACT_CODE_POSTAL] (state, value) {
    state.codePostal = value
  },
  [types.PROJECT_CONTACT_VILLE] (state, value) {
    state.ville = value
  },
  [types.PROJECT_CONTACT_DEPARTEMENT] (state, value) {
    state.departement = value
  },
  [types.PROJECT_CONTACT_SOCIETE] (state, value) {
    state.societe = value
  },
  [types.PROJECT_CONTACT_TYPE_OPERATION] (state, value) {
    state.typeOperations = value
  },
  [types.PROJECT_CONTACT_TYPE_ERP] (state, value) {
    state.typeErp = value
  },
  [types.PROJECT_CONTACT_CLIENT] (state, value) {
    state.client = value
  },
  [types.PROJECT_CONTACT_ETAT] (state, value) {
    state.etat = value
  },
  [types.PROJECT_CONTACT_NUMERO_AFFAIRE] (state, value) {
    state.numeroAffaire = value
  },
  [types.LIST_PROJETS] (state, value) {
    state.listProjets = value
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/projectForm/mutations.js